const card = {
  padding: '1rem',
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  flexWrap: 'wrap',
};

// On desktop the wrapper "dissolves" (display: contents) so the color picker and
// the Select Site field become direct children of the Card. This makes Select Site
// a true sibling of Select Tag, so both share `selectFieldBox` and end up identical
// in width. On small screens it falls back to a flex row that groups
// color picker + site + close button together.
const siteRowWrapper = {
  display: 'contents',
  '@media (max-width: 767px)': {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    width: '100%',
  },
};

// Shared style for the Select Site and Select Tag boxes so they behave identically.
const selectFieldBox = {
  display: 'flex',
  flex: '1 1 0',
  minWidth: '180px',
};

// Narrow fields holding short values (Interval, Aggregation).
const smallFieldBox = {
  display: 'flex',
  flex: '0 0 130px',
};

const colorBox = {
  display: 'flex',
  flexShrink: 0,
  gap: '5px',
};

const colorSwatch = (color: string) => ({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: color,
});

export { card, siteRowWrapper, selectFieldBox, smallFieldBox, colorBox, colorSwatch };
